const RightArrow = ({ size }) => {
  return (
    <svg
      viewBox='0 0 1024 1024'
      width={size || 14}
      height={size || 14}
      version='1.1'
      fill='currentColor'
    >
      <g id='SVGRepo_bgCarrier' stroke-width='0'></g>
      <g
        id='SVGRepo_tracerCarrier'
        stroke-linecap='round'
        stroke-linejoin='round'
      ></g>
      <g id='SVGRepo_iconCarrier'>
        <path
          d='M256 120.768L306.432 64 768 512l-461.568 448L256 903.232 659.072 512z'
          fill='currentColor'
        ></path>
      </g>
    </svg>
  )
}

export default RightArrow
